/* PetalHush P-092b: quantity tiles ("qty_tiers" block, snippets/ph-qty-tiers) and the optional gift box add-on
   ("addon_box" block, snippets/ph-addon-box) in the ph-breed-product buy box. Docs: theme/P-092-BALL-ORNAMENT.md §9.
   No app, no dependencies. One controller per product form, registered on window.PetalHushQB, which
   assets/petalhush-breed.js calls through three P-092b hooks (each a no-op when this file or the blocks are absent):
     PetalHushQB.total(form, total, price, n)  -> the Total / sticky price: the selected tile's per-piece price replaces the
                                                 variant price (x n), plus the ticked gift boxes (box price x box quantity)
     PetalHushQB.sel(form, name, n)            -> sticky-bar name "{size} · {pieces}" (null = the section's own text)
     PetalHushQB.items(form, forWhat, fd)      -> extra lines for the buy box's own /cart/add.js call (the add-on fee call,
                                                 rolled back when the piece fails): the gift box, quantity = its stepper,
                                                 hidden "_Box for" (SKU · title) + "_Box id"; the piece gets the same
                                                 "_Box id". Also drops the tiles' radio field from the multipart form.
   Tiles: picking one sets the form's hidden quantity input and fires "change" on it, so petalhush-breed.js repaints the
   Total, the sticky bar and the returns lines as usual. Prices per variant come from the server-rendered data-p map
   (the ladder is product data, never code). Changing the Size repaints the per-piece prices and the savings line.
   Gift box: never pre-ticked; the stepper is disabled until ticked; its value = the number of pieces until the shopper
   changes it (then it stays), not capped (a hint shows when it is above the number of pieces).
   P-092d PACKS AS VARIANTS (fieldset data-ph-qt-mode="variant", snippets/ph-qty-tiers): each tile is a value of the
   product's pack option ("4 pieces") with data-v = [[size, variant id, price, available, SKU, compare-at], …]. Picking a
   tile rewrites the Size cards (radios name="id": value, data-price, data-sku, data-compare, disabled, aria-label, the
   card's price line) to that pack's variants, keeps the hidden quantity at 1, fires "change" on it (petalhush-breed.js
   repaints price line, Total, sticky bar) and puts ?variant= in the URL. Per-piece = pack price / n; savings = 1-piece
   price x n - pack price; the gift box follows n (pieces in the pack), not the quantity. The Total hook adds the boxes
   only (the variant price is already the pack total). */
(function () {
  'use strict';
  if (window.PetalHushQB) return;
  var ctrls = [];

  function tpl(s, map) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function money(cents, format) {   // = petalhush-breed.js money(): "$27", "$5.95"
    var n = cents / 100, whole = Math.round(n) === n;
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      var v = whole ? String(n) : n.toFixed(2);
      if (k.indexOf('comma') !== -1) v = v.replace('.', ',');
      return v.replace(/\B(?=(\d{3})+(?!\d))/g, k.indexOf('comma') !== -1 ? '.' : ',');
    });
  }
  function json(el) { try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function find(form) {
    for (var i = ctrls.length - 1; i >= 0; i--) if (ctrls[i].form === form && document.documentElement.contains(form)) return ctrls[i];
    return null;
  }

  function init(form) {
    var qt = form.querySelector('[data-ph-qt]'), ab = form.querySelector('[data-ph-ab]');
    if ((!qt && !ab) || form.__phQB) return;
    form.__phQB = true;
    var root = form.closest('[data-ph-breed]');
    var C = json(root && root.querySelector('[data-ph-breed-config]'));
    var fmt = C.moneyFormat;
    var qtyEl = form.querySelector('input[name="quantity"]');
    var VM = !!(qt && qt.dataset.phQtMode === 'variant');   // P-092d: packs are variants (the pack option), quantity stays 1
    function n() {
      if (VM) {   // pieces = custom.pieces (or the number in the value) x the line quantity (always 1 in variant mode)
        var s = selTile(), k = s ? parseInt(s.dataset.phQtN, 10) : 1, q = qtyEl ? parseInt(qtyEl.value, 10) : 1;
        k = (k >= 1 ? k : 1) * (q >= 1 ? q : 1); return k <= 99 ? k : 99;
      }
      var v = qtyEl ? parseInt(qtyEl.value, 10) : 1; return v >= 1 && v <= 99 ? v : 1;
    }
    function variant() { return form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]'); }
    function kick() { if (qtyEl) qtyEl.dispatchEvent(new Event('change')); }   // petalhush-breed.js update() listens here

    /* ---------- tiles ---------- */
    var QT = json(qt && qt.querySelector('[data-ph-qt-t]'));
    var tiles = qt ? Array.prototype.slice.call(qt.querySelectorAll('input[data-ph-qt-n]')) : [];
    var saveEl = qt && qt.querySelector('[data-ph-qt-save]');
    tiles.forEach(function (t) { try { t._p = JSON.parse(t.dataset.p || '{}'); } catch (e) { t._p = {}; } });
    function selTile() { return tiles.filter(function (t) { return t.checked; })[0] || null; }

    /* ---------- P-092d: packs as variants ---------- */
    var cards = Array.prototype.slice.call(form.querySelectorAll('input[name="id"]'));
    if (VM) tiles.forEach(function (t) {
      var m = {}; try { JSON.parse(t.dataset.v || '[]').forEach(function (e) { m[e[0]] = { id: e[1], p: e[2], a: !!e[3], s: e[4], c: e[5] || 0 }; }); } catch (e) {}
      t._v = m;
    });
    function packN(t) { var k = parseInt(t.dataset.phQtN, 10); return k >= 1 ? k : 0; }   // 0 = a pack name without a number
    function packOf(t, sz) { return t && t._v ? t._v[sz] || null : null; }
    function applyPack() {   // the Size cards become the selected pack's variants; returns true when the checked id changed
      var t = selTile(), cur = variant(), before = cur ? cur.value : '';
      if (!t) return false;
      cards.forEach(function (r) {
        var e = packOf(t, r.dataset.metal);
        if (!e) { r.disabled = true; return; }
        r.value = String(e.id); r.dataset.price = String(e.p); r.dataset.sku = e.s || ''; r.dataset.compare = e.c > e.p ? String(e.c) : '';
        r.disabled = !e.a;
        r.setAttribute('aria-label', r.dataset.metal + ', ' + money(e.p, fmt));
        var pr = r.parentNode.querySelector('[data-ph-mprice]'); if (pr && e.a) pr.textContent = money(e.p, fmt);
      });
      if (qtyEl) qtyEl.value = '1';
      cur = variant();
      return !!cur && cur.value !== before;
    }
    function syncUrl() {   // = petalhush-breed.js syncUrl() for the variant (breed param untouched)
      var v = variant(); if (!v || !window.history.replaceState) return;
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.value); window.history.replaceState(window.history.state, '', u.toString()); } catch (e) {}
    }
    function syncCount() {   // P-113b S1: the studio count field the section bound to the pack option (data-ph-pz-follow) = the tile's number
      var c = VM ? (root || form).querySelector('[data-ph-pz-follow] select[data-ph-pz-count]') : null, t = selTile(), k = t ? parseInt(t.value, 10) : 0;
      if (!c || !(k >= 1) || c.value === String(k) || !c.querySelector('option[value="' + k + '"]')) return;
      c.value = String(k); c.dispatchEvent(new Event('change'));   // petalhush-breed.js applyCount(): Name 1..k show and post
    }
    function tileOf(k) { return tiles.filter(function (t) { return +t.value === k; })[0] || null; }
    function unit(k) {   // per-piece price of the selected variant at quantity k (null = no tile for k)
      if (VM) return null;   // P-092d: the variant price is the pack total already
      var t = tileOf(k), v = variant();
      if (!t || !v) return null;
      var u = t._p[v.value];
      return typeof u === 'number' && u > 0 ? u : null;
    }
    function word(k) {
      if (VM) { var s = selTile(); return s ? s.dataset.word : tpl(QT.one, {}); }
      var t = tileOf(k); return t ? t.dataset.word : tpl(k === 1 ? QT.one : QT.many, { n: k });
    }
    function paintPacks() {   // P-092d: per-piece prices, disabled tiles and the savings line for the selected size
      var v = variant(), sz = v ? v.dataset.metal : '', s = selTile();
      var one = tiles.filter(function (t) { return packN(t) === 1; })[0];
      var oneE = packOf(one, sz);
      tiles.forEach(function (t) {
        var e = packOf(t, sz), k = packN(t), each = t.parentNode.querySelector('[data-ph-qt-each]');
        t.disabled = !e || !e.a;
        if (!e) { if (each) each.textContent = ''; return; }
        var price = money(k ? Math.round(e.p / k) : e.p, fmt);
        if (each) each.textContent = k ? tpl(QT.each, { price: price }) : price;
        t.setAttribute('aria-label', k ? tpl(QT.aria, { pieces: t.dataset.word, price: price }) : t.dataset.word + ', ' + price);
      });
      if (saveEl) {
        var e = packOf(s, sz), k = s ? packN(s) : 0, save = e && oneE && k > 1 ? oneE.p * k - e.p : 0;
        var on = save > 0 && !!QT.save;
        saveEl.hidden = !on;
        saveEl.textContent = on ? tpl(QT.save, { amount: money(save, fmt) }) : '';
      }
    }
    function paintTiles() {
      if (!qt) return;
      if (VM) return paintPacks();
      var v = variant(), k = n();
      tiles.forEach(function (t) {
        var u = v ? t._p[v.value] : null; if (typeof u !== 'number') return;
        var each = t.parentNode.querySelector('[data-ph-qt-each]');
        if (each) each.textContent = tpl(QT.each, { price: money(u, fmt) });
        t.setAttribute('aria-label', tpl(QT.aria, { pieces: t.dataset.word, price: money(u, fmt) }));
        t.checked = +t.value === k;
      });
      if (saveEl) {
        var one = unit(1) || (v ? +v.dataset.price : 0), u = unit(k), save = u == null ? 0 : (one - u) * k;
        var on = k > 1 && save > 0 && !!QT.save;
        saveEl.hidden = !on;
        saveEl.textContent = on ? tpl(QT.save, { amount: money(save, fmt) }) : '';
      }
    }
    tiles.forEach(function (t) {
      t.addEventListener('change', function () {
        if (!t.checked) return;
        if (VM) { applyPack(); syncUrl(); syncCount(); }   // P-092d: the pack variant, quantity 1; P-113b S1: the bound count follows
        else if (qtyEl) qtyEl.value = String(+t.value);
        if (box) box.follow();
        paintTiles(); kick();
      });
    });
    form.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') { paintTiles(); if (box) box.paint(); } });

    /* ---------- gift box ---------- */
    var box = null;
    if (ab && ab.dataset.available === 'true') box = (function () {
      var AT = json(ab.querySelector('[data-ph-ab-t]'));
      var on = ab.querySelector('[data-ph-ab-on]'), q = ab.querySelector('[data-ph-ab-qty]');
      var dec = ab.querySelector('[data-ph-ab-dec]'), inc = ab.querySelector('[data-ph-ab-inc]');
      var hint = ab.querySelector('[data-ph-ab-hint]'), live = ab.querySelector('[data-ph-ab-live]');
      var edited = false, id = +ab.dataset.variant, price = +ab.dataset.price;
      on.checked = false;   // never pre-ticked, also after a back/forward restore
      function qty() { var v = parseInt(q.value, 10); return v >= 1 && v <= 99 ? v : 1; }
      function set(v) { q.value = String(Math.max(1, Math.min(99, v))); }
      function say(t) { if (!live) return; live.textContent = ''; setTimeout(function () { live.textContent = t || ''; }, 30); }
      function sayQty() { say(qty() === 1 ? AT.added : tpl(AT.addedN, { n: qty() })); }
      function paint() {
        var o = on.checked;
        q.disabled = !o; dec.disabled = !o || qty() <= 1; inc.disabled = !o || qty() >= 99;
        if (hint) hint.hidden = !(o && qty() > n());
        ab.classList.toggle('is-on', o);
      }
      function follow() { if (!edited) set(n()); paint(); }
      on.addEventListener('change', function () { if (on.checked && !edited) set(n()); paint(); if (on.checked) sayQty(); else say(AT.removed); kick(); });
      dec.addEventListener('click', function () { edited = true; set(qty() - 1); paint(); sayQty(); kick(); if (dec.disabled) q.focus(); });
      inc.addEventListener('click', function () { edited = true; set(qty() + 1); paint(); sayQty(); kick(); if (inc.disabled) q.focus(); });
      q.addEventListener('input', function () { if (q.value === '') return; edited = true; paint(); kick(); });
      q.addEventListener('change', function () { edited = true; set(qty()); paint(); sayQty(); kick(); });
      set(n()); paint();
      return {
        paint: paint, follow: follow,
        cents: function () { return on.checked ? price * qty() : 0; },
        line: function (forWhat, fd) {
          if (!on.checked) return null;
          var bid = 'bx' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
          if (fd) fd.set('properties[_Box id]', bid);
          return { id: id, quantity: qty(), properties: { '_Box for': forWhat, '_Box id': bid } };
        }
      };
    })();

    /* ---------- hooks for petalhush-breed.js ---------- */
    var api = {
      form: form,
      total: function (total, price, k) {
        var u = unit(k);
        if (u != null) total = total - (price - u) * k;
        if (box) total += box.cents();
        return total;
      },
      sel: function (name, k) { return qt && QT.sticky ? tpl(QT.sticky, { size: name, pieces: word(k) }) : null; },
      items: function (forWhat, fd) {
        if (fd && QT.name) fd.delete(QT.name);
        var l = box ? box.line(forWhat, fd) : null;
        return l ? [l] : [];
      }
    };
    ctrls = ctrls.filter(function (c) { return document.documentElement.contains(c.form); });
    ctrls.push(api);
    if (VM) {   // P-092d: a tile must be selected; a restored form may hold another pack than the cards: align the cards to it
      if (!selTile() && tiles.length) { var ft = tiles.filter(function (t) { return !t.disabled; })[0] || tiles[0]; ft.checked = true; }
      if (applyPack()) syncUrl();
      syncCount();   // P-113b S1: a restored form may hold another tile than the count
    } else if (qtyEl && !tileOf(n()) && tiles.length) qtyEl.value = '1';   // a restored form with a quantity that has no tile
    paintTiles();
    kick();   // Total + sticky follow the tiles / box from the start
  }

  window.PetalHushQB = {
    total: function (form, total, price, k) { var c = find(form); return c ? c.total(total, price, k) : total; },
    sel: function (form, name, k) { var c = find(form); return c ? c.sel(name, k) : null; },
    items: function (form, forWhat, fd) { var c = find(form); return c ? c.items(forWhat, fd) : []; }
  };
  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('form[data-ph-form]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
